import { useCallback, useState, CSSProperties, RefCallback } from 'react'
import { useBinary } from '~/hooks/useBinary'

type UseShowMoreDescription = (maxLineCount: number) => {
  textRef: RefCallback<Element | null>
  cssProperties: CSSProperties
  hasMore: boolean
  isOpen: boolean
  open: () => void
  close: () => void
}
export const useShowMoreDescription: UseShowMoreDescription = (
  maxLineCount
) => {
  const [isOpen, open, close] = useBinary(false)
  const [textHeight, setTextHeight] = useState(0)
  const [displayLineCount, setDisplayLineCount] = useState(0)
  const [lineHeight, setLineHeight] = useState(0)

  const hasMore = textHeight > lineHeight * maxLineCount

  const cssProperties: CSSProperties =
    lineHeight === 0 || isOpen
      ? {}
      : { height: `${lineHeight * displayLineCount}px` }

  const textRef = useCallback(
    (node: Element | null) => {
      if (!node) return
      const nodeHeight = node.getBoundingClientRect().height
      setTextHeight(nodeHeight)
      const computedLineHeight = Number(
        getComputedStyle(node)
          .getPropertyValue('line-height')
          .replace(/[^-\d.]/g, '')
      )
      setLineHeight(computedLineHeight)

      const lineCount = Math.round(nodeHeight / computedLineHeight)
      setDisplayLineCount(Math.min(maxLineCount, lineCount))
    },
    [maxLineCount]
  )

  return {
    textRef,
    cssProperties,
    hasMore,
    isOpen,
    open,
    close,
  }
}
